import { render, staticRenderFns } from "./VCarousel.vue?vue&type=template&id=a852ac52&scoped=true&"
import script from "./VCarousel.vue?vue&type=script&lang=js&"
export * from "./VCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VCarousel.vue?vue&type=style&index=0&id=a852ac52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a852ac52",
  null
  
)

export default component.exports